// extracted by css-extract-rspack-plugin
export default {"PaneTitle":"BwczL","PaneHeader":"zP27O","PanelSubheader":"aSEPO","PaneButton":"SVZHo","ButtonIcon":"NFLY6"};